export const mediaItems = [
  {
    id: 1,
    title: '国际执法联合打击暗网毒品交易：Hydra继任者Oasis Market被查封',
    summary: '欧洲刑警组织联合FBI展开代号"暗潮"的专项行动，查封暗网最大毒品交易平台Oasis Market，逮捕12名核心运营人员，查获价值超2.3亿美元的加密资产。',
    duration: '04:32',
    views: '128.6万',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Dark%20web%20law%20enforcement%20operation%20with%20digital%20forensics%20screens%2C%20dramatic%20lighting%2C%20abstract%20cyber%20security%20concept%2C%20red%20and%20dark%20tones%2C%20editorial%20style%2C%20professional%20photography%20with%20soft%20shadows&width=800&height=450&seq=media-01&orientation=landscape'
  },
  {
    id: 2,
    title: '暗网勒索软件BlackLock新变种曝光：利用零日漏洞攻击全球医疗机构',
    summary: '知名勒索软件组织BlackLock发布全新变种，利用CVE-2026-3842零日漏洞攻击北美及欧洲多家大型医院，赎金要求以Monero支付，安全专家紧急发布防御指南。',
    duration: '06:15',
    views: '96.3万',
    date: '2026-07-27',
    image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20ransomware%20attack%20concept%20on%20hospital%20systems%2C%20dark%20dramatic%20scene%20with%20digital%20lock%20icons%2C%20medical%20monitors%20in%20background%2C%20warm%20amber%20warning%20tones%2C%20cinematic%20lighting&width=800&height=450&seq=media-02&orientation=landscape'
  },
  {
    id: 3,
    title: '暗网泄露：全球5000万张信用卡信息在黑市论坛被兜售',
    summary: '暗网监测平台发现大规模信用卡数据泄露事件，涉及全球50余家银行客户信息，数据来源疑似为某大型支付处理商API漏洞，卖家以比特币定价批量出售。',
    duration: '05:48',
    views: '215.7万',
    date: '2026-07-26',
    image: 'https://readdy.ai/api/search-image?query=Dark%20web%20data%20breach%20credit%20card%20information%20leak%20concept%2C%20digital%20theft%20visualization%20with%20binary%20code%2C%20shadowy%20digital%20marketplace%2C%20deep%20red%20and%20black%20atmosphere%2C%20editorial%20style&width=800&height=450&seq=media-03&orientation=landscape'
  },
  {
    id: 4,
    title: '深度解析：Tor网络匿名性面临AI流量分析技术新挑战',
    summary: '最新研究表明基于深度学习的流量关联攻击技术取得突破，Tor匿名网络的隐私保护能力面临前所未有的威胁，暗网社区紧急讨论应对方案与技术升级路线。',
    duration: '08:20',
    views: '73.9万',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=AI%20network%20traffic%20analysis%20visualization%20threatening%20anonymous%20networks%2C%20abstract%20data%20flow%20with%20neural%20network%20overlay%2C%20dark%20technical%20aesthetic%2C%20teal%20and%20crimson%20accents%2C%20futuristic%20cybersecurity%20art&width=800&height=450&seq=media-04&orientation=landscape'
  }
];

export const faqItems = [
  {
    id: 1,
    question: '51暗网是什么？如何区别于其他暗网资讯平台？',
    answer: '51暗网是国内领先的暗网新闻与安全动态追踪平台，专注于暗网黑市动态、网络犯罪事件、数据泄露情报及全球暗网安全政策变化的实时报道。与普通安全资讯平台不同，我们拥有专业的情报分析团队，提供深度的暗网事件拆解、攻击链还原及趋势研判，帮助读者理解暗网世界背后的真实生态。'
  },
  {
    id: 2,
    question: '51暗网的信息来源是否可靠？如何保证内容真实性？',
    answer: '我们建立了严格的三级信息核验机制：一线情报团队通过暗网监测工具获取原始数据；分析团队交叉验证多个独立信源；编辑团队最终审核发布。对于未经充分证实的信息，我们会明确标注"待核实"状态。同时，平台所有深度分析均由具备网络安全从业背景的资深分析师撰写，确保专业可信。'
  },
  {
    id: 3,
    question: '普通用户浏览暗网相关内容是否合法？需要注意什么？',
    answer: '浏览暗网相关的公开新闻报道和资讯分析完全合法。51暗网发布的所有内容均为已公开的安全事件报道和专业分析，不提供任何访问暗网的教程或工具。我们强烈建议普通用户通过正规渠道了解网络安全动态，切勿出于好奇尝试访问暗网，以免触犯法律或遭遇安全风险。'
  },
  {
    id: 4,
    question: '51暗网的更新频率如何？是否可以第一时间获取暗网重大事件信息？',
    answer: '我们保持7×24小时全天候更新机制，暗网快讯平均日更新50条以上。对于重大暗网安全事件（如大规模数据泄露、国际执法行动、新型勒索软件爆发等），我们通常能在事件公开后的30分钟内发布首条快讯，并在2小时内完成深度分析报道。建议开启浏览器通知或关注我们的社交媒体账号以获取实时推送。'
  },
  {
    id: 5,
    question: '如何在51暗网投稿或提供暗网相关线索？',
    answer: '我们欢迎安全研究者、白帽黑客和知情人士提供暗网相关的新闻线索或情报信息。您可以通过平台"联系我们"栏目的专用投稿邮箱提交信息，支持PGP加密通信以确保信源安全。对于高质量独家线索，平台将根据信息的新闻价值和影响力提供相应稿酬。投稿前请确保不涉及任何违法行为或侵犯他人隐私。'
  }
];

export const updateItems = [
  {
    id: 1,
    date: '2026-07-29',
    time: '14:32',
    tag: '黑市动态',
    title: '暗网市场Abacus宣布支持Solana链上交易，规避传统混币器监管',
    summary: '知名暗网市场Abacus发布公告，即日起接受Solana链上USDC作为支付方式，声称该链交易速度快、费用低且更难被链上分析工具追踪。'
  },
  {
    id: 2,
    date: '2026-07-29',
    time: '10:15',
    tag: '犯罪事件',
    title: '暗网雇佣黑客攻击南美政府数据库，200万公民信息遭窃取',
    summary: '某南美国家政府数据库遭受定向攻击，攻击者通过暗网雇佣平台招募黑客团队，利用SQL注入漏洞入侵系统。'
  },
  {
    id: 3,
    date: '2026-07-28',
    time: '22:40',
    tag: '安全政策',
    title: '欧盟通过新网络安全法案，要求暗网监测纳入国家安全体系',
    summary: '欧盟议会投票通过《网络安全与威胁情报法案》，首次将系统性暗网监测列为成员国网络安全机构的法定职责。'
  },
  {
    id: 4,
    date: '2026-07-28',
    time: '16:08',
    tag: '数据泄露',
    title: '暗网论坛出现疑似国内某社交平台用户数据库，涉及800万条记录',
    summary: '暗网知名数据交易论坛出现一条新帖，卖家声称掌握某大型社交平台2024年的用户数据库，以8 BTC起拍。'
  },
  {
    id: 5,
    date: '2026-07-27',
    time: '19:55',
    tag: '吃瓜爆料',
    title: '暗网组织AnonymousFox声称已渗透某跨国企业内网，公布部分内部邮件',
    summary: '自称AnonymousFox的黑客组织在暗网发布声明，称已成功渗透某Fortune 500企业内网，并公开数十封高管内部邮件作为证据。'
  },
  {
    id: 6,
    date: '2026-07-27',
    time: '11:20',
    tag: '黑市动态',
    title: '暗网武器交易板块活跃度激增，AI生成3D打印枪械图纸成新趋势',
    summary: '监测数据显示暗网武器交易板块2026年Q2交易量同比增长47%，其中AI生成的3D打印枪械图纸成为热门品类。'
  },
  {
    id: 7,
    date: '2026-07-26',
    time: '08:45',
    tag: '安全技术',
    title: 'Chainalysis发布2026上半年暗网加密货币流动报告，Monero占比首超比特币',
    summary: '区块链分析公司Chainalysis发布最新报告，显示2026年上半年暗网交易中Monero使用率首次超过比特币，占比达52.3%。'
  }
];

export const cardItems = [
  {
    id: 1,
    category: '深度调查',
    title: '暗网毒品帝国沉浮录：从丝绸之路到Oasis Market的十年进化',
    excerpt: '从2011年Ross Ulbricht创建丝绸之路至今，暗网毒品交易经历了怎样的技术迭代与组织变迁？本文回顾暗网毒品市场的完整演化图谱。',
    author: '暗网调查组',
    date: '2026-07-27',
    readTime: '18分钟',
    image: 'https://readdy.ai/api/search-image?query=Dark%20web%20drug%20marketplace%20evolution%20timeline%20concept%2C%20shadowy%20digital%20market%20with%20historical%20progression%20visualization%2C%20dark%20red%20and%20black%20tones%2C%20investigative%20journalism%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape'
  },
  {
    id: 2,
    category: '技术分析',
    title: '暗网托管基础设施揭秘：Bulletproof Hosting的灰色产业链',
    excerpt: '防弹托管服务是暗网生态系统的核心基础设施。我们深入调查了全球最大的几个防弹托管服务商及其背后的运作网络，揭示这个年产值数十亿美元的灰色产业。',
    author: '技术分析组',
    date: '2026-07-26',
    readTime: '14分钟',
    image: 'https://readdy.ai/api/search-image?query=Bunker%20server%20farm%20bulletproof%20hosting%20concept%2C%20underground%20data%20center%20with%20cables%20and%20servers%2C%20industrial%20dark%20aesthetic%2C%20technical%20photography%20with%20warm%20amber%20accents&width=600&height=400&seq=card-02&orientation=landscape'
  },
  {
    id: 3,
    category: '政策解读',
    title: '2026全球暗网监管政策大洗牌：五国新法案深度对比',
    excerpt: '美国、欧盟、俄罗斯、日本、印度相继出台针对暗网活动的新监管法案。本文从执法权力、隐私边界、技术合规三个维度深度对比五国政策框架。',
    author: '政策研究组',
    date: '2026-07-25',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Global%20dark%20web%20regulation%20policy%20comparison%20concept%2C%20world%20map%20with%20legal%20documents%20and%20digital%20themes%2C%20professional%20dark%20editorial%20style%2C%20clean%20typography%20overlay&width=600&height=400&seq=card-03&orientation=landscape'
  },
  {
    id: 4,
    category: '吃瓜爆料',
    title: '暗网信息贩子曝光：某国内明星隐私数据在地下论坛叫卖',
    excerpt: '暗网某知名数据交易平台出现一条针对国内娱乐圈的帖子，卖家声称掌握多位一线明星的私人行程、通讯记录等敏感数据，引发暗网社区热议。',
    author: '吃瓜前线',
    date: '2026-07-24',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Data%20privacy%20breach%20celebrity%20information%20on%20dark%20web%20concept%2C%20silhouette%20with%20digital%20data%20streams%2C%20mysterious%20dark%20atmosphere%2C%20paparazzi%20investigative%20style%2C%20warm%20red%20accents&width=600&height=400&seq=card-04&orientation=landscape'
  },
  {
    id: 5,
    category: '安全防护',
    title: '暗网勒索软件即服务(RaaS)模式全解析：普通人如何自保？',
    excerpt: '勒索软件即服务使网络犯罪门槛大幅降低。本文完整拆解RaaS的商业模式、攻击流程和支付链条，并为企业和个人提供实用的防御策略清单。',
    author: '安全防护组',
    date: '2026-07-23',
    readTime: '16分钟',
    image: 'https://readdy.ai/api/search-image?query=Ransomware%20as%20a%20service%20dark%20web%20concept%2C%20digital%20extortion%20visualization%20with%20lock%20and%20chain%20symbols%2C%20cyber%20crime%20business%20model%2C%20dark%20industrial%20aesthetic%2C%20teal%20and%20red%20highlights&width=600&height=400&seq=card-05&orientation=landscape'
  },
  {
    id: 6,
    category: '事件追踪',
    title: '暗网黑市King\'s Road关闭内幕：管理团队内讧与用户资金疑云',
    excerpt: '运营三年半的暗网黑市King\'s Road突然关闭，官方声明称因管理团队分歧，但大量用户反映托管资金无法提现。我们梳理了事件的完整时间线。',
    author: '事件追踪组',
    date: '2026-07-22',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Dark%20web%20marketplace%20exit%20scam%20concept%2C%20abandoned%20digital%20storefront%20with%20error%20messages%2C%20mysterious%20cloaked%20figure%20silhouette%2C%20deep%20amber%20and%20black%20tones%2C%20dramatic%20editorial%20photography&width=600&height=400&seq=card-06&orientation=landscape'
  }
];

export const topicItems = [
  { id: 1, name: '暗网黑市', heat: '298.6万', trend: 'up', posts: '12,845' },
  { id: 2, name: '数据泄露', heat: '256.3万', trend: 'up', posts: '9,721' },
  { id: 3, name: '勒索软件', heat: '198.7万', trend: 'up', posts: '8,432' },
  { id: 4, name: 'Tor网络', heat: '175.4万', trend: 'stable', posts: '7,156' },
  { id: 5, name: '加密货币洗钱', heat: '162.8万', trend: 'up', posts: '6,983' },
  { id: 6, name: '零日漏洞', heat: '148.2万', trend: 'up', posts: '5,647' },
  { id: 7, name: '暗网执法', heat: '136.9万', trend: 'stable', posts: '5,210' },
  { id: 8, name: '吃瓜爆料', heat: '289.1万', trend: 'up', posts: '15,320' },
  { id: 9, name: '网络安全政策', heat: '125.6万', trend: 'down', posts: '4,891' }
];

export const aboutContent = {
  title: '关于51暗网',
  description: '51暗网成立于2023年，是国内首个专注于暗网新闻动态与安全情报追踪的专业平台。我们汇聚了一支由前网络安全工程师、调查记者和数据分析师组成的核心团队，致力于在纷繁复杂的暗网信息中，为读者提供准确、深度、及时的暗网事件报道和安全趋势分析。\n\n我们的使命是成为连接公众与暗网安全世界的可信桥梁——既不为猎奇而渲染暗网的阴暗面，也不回避暗网对现实社会造成的真实威胁。通过对暗网黑市动态、网络犯罪事件和安全政策的持续追踪，帮助个人用户和企业机构建立领先的网络安全认知。\n\n截至目前，平台日均更新暗网快讯超过50条，深度报道覆盖全球12个主要暗网市场和30余个活跃黑客组织的最新动态。',
  stats: [
    { value: '50+', label: '日均快讯更新' },
    { value: '1,200+', label: '深度报道已发布' },
    { value: '300万+', label: '月度活跃读者' },
    { value: '12', label: '覆盖暗网市场' }
  ]
};

export const indexItems = [
  {
    id: 1,
    title: '暗网黑市完全档案',
    description: '收录全球活跃暗网黑市的完整资料，包括市场历史、运营模式、交易品类和执法动态。',
    count: '38篇',
    icon: 'ri-store-2-line'
  },
  {
    id: 2,
    title: '勒索软件家族图谱',
    description: '系统梳理全球活跃勒索软件组织的技术特征、攻击手法和赎金支付链路。',
    count: '24篇',
    icon: 'ri-virus-line'
  },
  {
    id: 3,
    title: '数据泄露事件库',
    description: '按行业和时间线整理重大数据泄露事件，包含泄露规模、数据类型和后续影响评估。',
    count: '67篇',
    icon: 'ri-database-2-line'
  },
  {
    id: 4,
    title: '暗网加密货币追踪',
    description: '关注暗网交易中的加密货币流动路径，分析混币器和隐私币使用趋势变化。',
    count: '19篇',
    icon: 'ri-bit-coin-line'
  },
  {
    id: 5,
    title: '黑客组织深度扒皮',
    description: '对全球主要黑客组织进行深度调查，披露其成员构成、攻击偏好和已知关联网络。',
    count: '31篇',
    icon: 'ri-spy-line'
  },
  {
    id: 6,
    title: '暗网安全政策追踪',
    description: '实时追踪全球各国针对暗网的立法动态、执法行动和国际合作机制变化。',
    count: '45篇',
    icon: 'ri-scales-3-line'
  },
  {
    id: 7,
    title: '全民吃瓜合集',
    description: '聚合暗网内幕爆料、名人隐私泄露和各类吃瓜事件，满足好奇心的同时警惕个人信息安全。',
    count: '53篇',
    icon: 'ri-emotion-line'
  }
];

export const rankingItems = [
  { id: 1, rank: 1, title: '暗网市场Abacus宣布支持Solana链上交易', heat: '328.6万', change: '+12%', tag: '24小时最热' },
  { id: 2, rank: 2, title: 'Chainalysis报告：暗网Monero使用率首超比特币', heat: '287.3万', change: '+8%', tag: '本周飙升' },
  { id: 3, rank: 3, title: '某国内明星隐私数据在暗网论坛叫卖', heat: '265.9万', change: '+35%', tag: '吃瓜热议' },
  { id: 4, rank: 4, title: '欧盟通过新网络安全法案要求暗网监测入法', heat: '231.4万', change: '+5%', tag: '政策关注' },
  { id: 5, rank: 5, title: '暗网勒索软件BlackLock利用零日漏洞攻击医疗机构', heat: '198.7万', change: '+18%', tag: '安全警报' }
];

export const carouselItems = [
  {
    id: 1,
    badge: '年度重磅',
    title: '2026全球暗网生态年度报告',
    description: '覆盖12大暗网市场、58个活跃黑客组织、逾300起重大事件的年度全景分析。从黑市交易额趋势到新型攻击技术演进，从国际执法行动成效到暗网社区文化变迁，一本报告读懂暗网这一年。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20web%20annual%20report%20concept%20with%20data%20visualization%20charts%2C%20global%20cyber%20threat%20landscape%2C%20professional%20dark%20editorial%20design%20with%20deep%20red%20accents%2C%20statistical%20infographics%2C%20clean%20modern%20layout&width=1200&height=600&seq=carousel-01&orientation=landscape'
  },
  {
    id: 2,
    badge: '深度系列',
    title: '暗网入门：从Tor到加密货币的完整认知体系',
    description: '8篇系列文章构建暗网认知框架。从Tor网络技术原理、暗网寻址机制、加密货币匿名特性到暗网市场运营模式，为零基础读者打造系统化的暗网知识体系，帮助建立正确的网络安全观。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20web%20knowledge%20system%20concept%2C%20onion%20routing%20visualization%20with%20layered%20encryption%2C%20educational%20cybersecurity%20illustration%2C%20dark%20technical%20aesthetic%20with%20warm%20amber%20glow%2C%20clean%20diagram%20style&width=1200&height=600&seq=carousel-02&orientation=landscape'
  },
  {
    id: 3,
    badge: '独家追踪',
    title: '暗网执法行动全记录：2025-2026重大跨国打击案例',
    description: '独家梳理近两年国际执法机构针对暗网犯罪的重大联合行动。从Operation DisrupTor到SpecTor行动，从Hydra覆灭到Oasis Market查封，完整还原每场执法行动的筹备、执行与后续影响。',
    image: 'https://readdy.ai/api/search-image?query=International%20law%20enforcement%20dark%20web%20operation%20concept%2C%20police%20raid%20digital%20visualization%2C%20dramatic%20lighting%2C%20cyber%20crime%20bust%2C%20professional%20dark%20documentary%20style%2C%20red%20and%20blue%20accents&width=1200&height=600&seq=carousel-03&orientation=landscape'
  },
  {
    id: 4,
    badge: '前沿观察',
    title: 'AI × 暗网：人工智能如何改变网络犯罪的攻防格局',
    description: 'AI生成的钓鱼邮件绕过传统检测，LLM辅助的恶意代码在暗网论坛流通，深度伪造技术催生新型勒索模式。与此同时，执法机构也在利用AI进行暗网情报分析——这场AI军备竞赛正在重塑暗网生态。',
    image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20and%20dark%20web%20intersection%20concept%2C%20neural%20network%20visualization%20morphing%20with%20dark%20digital%20patterns%2C%20futuristic%20cyber%20warfare%20art%2C%20deep%20teal%20and%20crimson%20tones%2C%20sophisticated%20technical%20aesthetic&width=1200&height=600&seq=carousel-04&orientation=landscape'
  }
];

export const commentItems = [
  {
    id: 1,
    author: '网安小白',
    avatar: '白',
    date: '2026-07-28',
    content: '关注51暗网快一年了，从完全不懂暗网是什么到现在能看懂大部分技术分析文章，这个平台真的帮我建立了完整的网络安全认知。特别推荐"暗网入门系列"，深入浅出，非常适合零基础读者。',
    article: '暗网入门：从Tor到加密货币的完整认知体系'
  },
  {
    id: 2,
    author: '信息安全工程师老K',
    avatar: 'K',
    date: '2026-07-27',
    content: '作为一名在安全行业干了8年的老鸟，51暗网的情报时效性和分析深度让我非常意外。很多暗网黑市的情报比我们公司付费买的威胁情报平台还要快，强烈建议同行关注。',
    article: '暗网黑市King\'s Road关闭内幕'
  },
  {
    id: 3,
    author: '吃瓜路人甲',
    avatar: '甲',
    date: '2026-07-26',
    content: '本来是冲着吃瓜内容来的，结果看着看着就把整个暗网安全科普看完了。以前觉得暗网离自己很远，现在才知道个人信息保护有多重要。希望平台越做越好，产出更多接地气的内容！',
    article: '暗网信息贩子曝光：某国内明星隐私数据在地下论坛叫卖'
  }
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-radar-line',
    title: '7×24实时追踪',
    description: '全天候监测暗网动态，重大事件30分钟内发布首条快讯，确保读者第一时间获取关键情报。'
  },
  {
    id: 2,
    icon: 'ri-team-line',
    title: '专业分析团队',
    description: '核心团队由前网络安全工程师、调查记者和数据分析师组成，确保每篇报道兼具专业深度与可读性。'
  },
  {
    id: 3,
    icon: 'ri-file-search-line',
    title: '多源交叉验证',
    description: '三级信息核验机制，交叉验证多个独立信源，未经证实信息明确标注状态，拒绝虚假情报传播。'
  },
  {
    id: 4,
    icon: 'ri-global-line',
    title: '全球暗网覆盖',
    description: '覆盖12个主要暗网市场和30余个活跃黑客组织，构建完整的暗网情报网络和事件追踪体系。'
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '安全意识倡导',
    description: '不仅报道暗网新闻，更致力于帮助读者建立正确的网络安全观，推动个人信息保护意识普及。'
  }
];

export const heroStats = [
  { value: '50+', label: '日均暗网快讯' },
  { value: '12', label: '覆盖暗网市场' },
  { value: '7×24', label: '全天候追踪' }
];